const clientFactory = (instance) => ({
    get: (url, config) => instance.get(url, config).then(response => response.data),
});

export { clientFactory };
//# sourceMappingURL=clientFactory.js.map
